import React, { useEffect } from 'react';
import Header from '../components/Header';
import TermsAndConditions from '../components/TermsAndConditions';
import Footer from '../components/Footer';
import { initSEO } from '../seo';

const TermsPage = () => {
  useEffect(() => {
    initSEO('terms');
  }, []);

  return (
    <>
      <Header />
      <TermsAndConditions />
      <Footer />
    </>
  );
};

export default TermsPage;
